import { render } from "./AdderHome.vue?vue&type=template&id=0467aae2&scoped=true"
import script from "./AdderHome.vue?vue&type=script&lang=js"
export * from "./AdderHome.vue?vue&type=script&lang=js"

import "./AdderHome.vue?vue&type=style&index=0&id=0467aae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0467aae2"]])

export default __exports__